import { _createStakingSubscription, _estimateStakingReward } from '../redux/actions'

// Helper to handle staking subscription creation
export const handleStakingSubscription = (poolData, amount, callbacks = {}) => {
    const { onSuccess, onError, onLoading } = callbacks

    if (onLoading) onLoading(true)

    _createStakingSubscription(
        {
            stakingPeriodId: poolData.id,
            amount
        },
        (response) => {
            if (onLoading) onLoading(false)
            if (onSuccess) onSuccess(response)
        },
        (error) => {
            if (onLoading) onLoading(false)
            if (onError) onError(error)
            console.error('Error creating staking subscription:', error)
        }
    )
}

// Helper to estimate staking rewards
export const estimateStakingRewards = (poolData, amount, callbacks = {}) => {
    const { onSuccess, onError, onLoading } = callbacks

    if (onLoading) onLoading(true)

    _estimateStakingReward(
        {
            stakingPeriodId: poolData.id,
            amount
        },
        (response) => {
            if (onLoading) onLoading(false)
            if (onSuccess) onSuccess(response)
        },
        (error) => {
            if (onLoading) onLoading(false)
            if (onError) onError(error)
            console.error('Error estimating staking reward:', error)
        }
    )
}

// Helper to format APR display
export const formatAPR = (apr) => {
    if (!apr || apr === 0) return '0.00'
    return parseFloat(apr).toFixed(2)
}

// Helper to format staking periods
export const formatStakingPeriods = (periods) => {
    if (!periods || !Array.isArray(periods)) return ['Flexible']

    return periods.map(period => {
        if (period.duration === 0 || period.duration === null) {
            return 'Flexible'
        }
        return `${period.duration} Days`
    })
}

// Helper to get the best APR from periods
export const getBestAPR = (periods) => {
    if (!periods || !Array.isArray(periods) || periods.length === 0) return 0

    const aprValues = periods.map(period => parseFloat(period.apr || 0))
    return Math.max(...aprValues)
}

// Helper to validate staking amount
export const validateStakingAmount = (amount, minAmount, maxAmount, userBalance) => {
    const numAmount = parseFloat(amount)
    const errors = []

    if (!amount || isNaN(numAmount) || numAmount <= 0) {
        errors.push('Please enter a valid amount')
    }

    if (minAmount && numAmount < minAmount) {
        errors.push(`Minimum staking amount is ${minAmount}`)
    }

    if (maxAmount && numAmount > maxAmount) {
        errors.push(`Maximum staking amount is ${maxAmount}`)
    }

    if (userBalance && numAmount > userBalance) {
        errors.push('Insufficient balance')
    }

    return {
        isValid: errors.length === 0,
        errors
    }
}
